import {
    CANDIDATE_PRO2_UPDATE_REQUEST,
    CANDIDATE_PRO2_UPDATE_SUCCESS,
    CANDIDATE_PRO2_UPDATE_FAIL,
} from "../constants/AuthConstant";

const initialState = {
    loading: false,
    error: null,
    success: false,
    data: null,
};

const candidateProUpdateReducer2 = (state = initialState, action) => {
    switch (action.type) {
        case CANDIDATE_PRO2_UPDATE_REQUEST:
            return {
                ...state,
                loading: action.payload,
            };

        case CANDIDATE_PRO2_UPDATE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                data: action.result,
                error: null,
            };
        case CANDIDATE_PRO2_UPDATE_FAIL:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.error,
                data: null,
            };

        default:
            return state;
    }
};

export default candidateProUpdateReducer2